import { createFileRoute } from "@tanstack/react-router";
import { ArchivedPage } from "@/features/memo/ArchivedPage";
import { requireAuth } from "@/lib/guards";

export const Route = createFileRoute("/archived")({
  beforeLoad: requireAuth,
  component: ArchivedPage,
});
